import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Financiers = () => {
  return (
    <div className='m-1'>
      <Title text="Financiadores"/>
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Financiers